
export const ACTION = {
  CHANGE_CASE_TYPE: 'CASE:CHANGE_CASE_TYPE',
  CHANGE_CASE_TYPE_FAILURE: 'CASE:FAIL_CHANGE_CASE_TYPE',
  CHANGE_CASE_TYPE_SUCCESS: 'CASE:SUCCESS_CHANGE_CASE_TYPE'
};

export class ChangeCaseType {
  public type: string = ACTION.CHANGE_CASE_TYPE;
  public caseTypeId: number;
  public draftId: number;

  constructor(caseTypeId: number, draftId: number) {
    this.caseTypeId = caseTypeId;
    this.draftId = draftId;
  }
}

export class ChangeCaseTypeSuccess {
  public type: string = ACTION.CHANGE_CASE_TYPE_SUCCESS;
  public caseTypeId: number;
  public draftId: number;
  public etag: string;
  constructor(caseTypeId: number, draftId: number, etag: string) {
    this.caseTypeId = caseTypeId;
    this.draftId = draftId;  
    this.etag = etag;
  }
}

export class ChangeCaseTypeFailure {
  public type: string = ACTION.CHANGE_CASE_TYPE_FAILURE;
  public draftId: number;
  constructor(caseTypeId: number, draftId: number) {
    this.draftId = draftId;  
  }
}
